export enum RouteDirection {
  NB = 'NB',
  SB = 'SB',
  EB = 'EB',
  WB = 'WB',
}
